<template>
  <v-dialog v-model="dialogOpen" width="800" persistent>
    <v-card>
      <v-card-title>Domain Name Search</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field dense outlined hide-details label="Search" v-model="searchText" v-on:keyup.enter="doSearch" :disabled="searchedDomainsLoading">
              <v-icon slot="append" color="secondary" v-if="searchText!==''" @click="doSearch">search</v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4" :disabled="searchedDomainsLoading">
            <v-select dense outlined hide-details multiple :items="tlds" v-model="tld" label="TLD"></v-select>
          </v-col>
        </v-row>
        <template v-if="getSearchedDomains.length>0">
          <v-divider></v-divider>
          <v-radio-group v-model="domain">
            <v-row>
              <template v-for="(dom,domi) in getSearchedDomains">
                <v-col :key="domi" cols="12" md="6">
                  <template v-if="dom.status==='taken'">
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }"><v-icon color="warning" v-bind="attrs" v-on="on">{{mdiAlert}}</v-icon></template>
                      <span>Not available</span>
                    </v-tooltip> <span class="warning--text ml-2">{{dom.name}}</span>
                  </template>
                  <template v-else>
                    <v-radio :value="dom.name" color="primary">
                      <template v-slot:label>
                        <span :class="(dom.type==='lookup')?`secondary--text`:`body--text`">{{dom.name}}</span>
                      </template>
                    </v-radio>
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-radio-group>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="searchedDomainsLoading||submitDisabled" :loading="searchedDomainsLoading">SELECT</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="searchedDomainsLoading">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mdiAlert } from '@mdi/js';
  import { mapState,mapActions,mapGetters,mapMutations } from "vuex";
  export default {
    props: ['dialogOpen','searchedText'],
    data() {
      return {
        searchText: '',
        domain: '',
        tld: ['.co.uk'],
        tlds: ['.com','.co.uk'],
        mdiAlert: mdiAlert,
      }
    },
    watch: {
      dialogOpen(open) {
        if(open){
          this.searchText = this.searchedText.split('.')[0];
        }
      }
    },
    computed: {
      ...mapState('productWebsite',['searchedDomainsLoading']),
      ...mapGetters('productWebsite',['getSearchedDomains']),
      submitDisabled(){
        return this.domain==='';
      },
    },
    methods: {
      ...mapActions('productWebsite',['fetchSearchedDomains']),
      ...mapMutations('productWebsite',['setSelectedDomain','setSearchedDomains']),
      async doSearch(){
        let data = {
          domain: this.searchText,
          tlds: this.tld,
        };
        this.setSearchedDomains({});
        await this.fetchSearchedDomains(data);
      },
      submit() {
        this.setSelectedDomain(this.domain);
        this.close();
      },
      close() {
        this.searchText = '';
        this.tld = ['.co.uk'];
        this.setSearchedDomains({});
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
